import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { SubCategory } from "../sub-category";
import { SubCategoryFieldConfigEntityConfig } from "./config";
import { SubCategoryFieldConfigFilters } from "./filters";
import { SubCategoryFieldConfigMethods } from "./methods";

export const SUB_CATEGORY_FIELD_INPUT_TYPES = [
  "TEXT",
  "NUMBER",
  "IMAGE",
  "BOOLEAN",
  "SELECT",
] as const;

export type SubCategoryFieldInputType =
  (typeof SUB_CATEGORY_FIELD_INPUT_TYPES)[number];

@HyperEntity("sub-category-field-config", SubCategoryFieldConfigEntityConfig)
export class SubCategoryFieldConfig extends extender(
  SubCategoryFieldConfigFilters,
  SubCategoryFieldConfigMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "sub_category_id" })
  subCategoryId = "";

  @Relations.toOne(() => SubCategory, "subCategoryId")
  subCategory?: SubCategory;

  @Fields.string()
  field = "";

  @Fields.string()
  label = "";

  @Fields.boolean({ dbName: "is_required" })
  isRequired = false;

  @Fields.string({ dbName: "default_value", allowNull: true })
  defaultValue: string | null = null;

  @Fields.literal(() => SUB_CATEGORY_FIELD_INPUT_TYPES)
  type: SubCategoryFieldInputType = "TEXT";

  @Fields.boolean({ dbName: "append_to_description" })
  appendToDescription = false;

  @Fields.json<string[]>()
  options: string[] = [];

  @Fields.number()
  order = 0;

  @Fields.boolean({ dbName: "is_visible" })
  isVisible = true;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
